import React from 'react';
export const xsollaProductsStatus = {
  currency: {
    status: 'enabled',
    statusName: 'Active',
    info: <div>
      <div>3 currencies</div>
      <div>26 packages</div>
    </div>
  },
  subscriptions: {
    status: 'enabled',
    statusName: 'Active',
    info: <div>
      <div>3 selling subscription plans</div>
    </div>
  },
  game_store: {
    status: 'enabled',
    statusName: 'Active',
    info: <div>
      <div>3 selling subscription plans</div>
    </div>
  },
  buy_button: {
    status: 'enabled',
    statusName: 'Active',
    info: <div>
      <div>1 widget</div>
    </div>
  },
  microtransactions: {
    status: 'enabled',
    statusName: 'Active',
    info: <div>
      <div>255 virtual items</div>
      <div>3 lootboxes</div>
      <div>1 active promotion</div>
    </div>
  },
  direct_link: {
    status: 'enabled',
    statusName: 'Active',
    info: <div>
    </div>
  },
  site_builder: {
    status: 'enabled',
    statusName: 'Active',
    info: <div>
    </div>
  },
  pay_station: {
    status: 'enabled',
    statusName: 'Active',
    info: <div>
      200 payment methods activated
    </div>
  },
  login: {
    status: 'testing',
    statusName: 'No logins created',
    info: <div>
    </div>
  },
  partner_network: {
    status: 'testing',
    statusName: 'not started',
    info: <div>
    </div>
  },
  virtual_items: {
    status: 'testing',
    statusName: 'not started',
    info: <div>
    </div>
  },
};
